import { Box, Button, ErrorDialog } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	const [error, setError] = useState<Error>(null);
	const [open, setOpen] = useState(false);
	const onClose = () => setOpen(false);
	const onButton = (err?: Error) => {
		setError(err);
		setOpen(true);
	};

	return (
		<Box>
			<CssColumnGrid columns={2}>
				<Button design="primary" onClick={() => onButton(new Error("There is an error in the system!"))}>
					Dialog with Error
				</Button>
				<Button design="primary" onClick={() => onButton()}>
					Dialog without Error
				</Button>
			</CssColumnGrid>
			<ErrorDialog
				error={error}
				onClose={onClose}
				open={open}
				title={error ? "System Error" : null}
			/>
		</Box>
	);
};